import { ActionContext, ActionTree } from 'vuex';
import {
  SET_APPLICATION_LIST,
  SET_CURRENT_APPLICATION,
  SET_IS_ADMIN_VARIABLE,
  DELETE_APPLICATION_CARD,
  ADD_NEW_MESSAGE,
  SET_APPLICATION_STEP,
  SET_APPLICATIONS_EXIST,
  LOAD_MORE_APPLICATIONS,
  SET_APPLICATION_ANSWERS,
  ADD_FEEDBACK,
  SET_TOTAL_OPEN,
  SET_TOTAL_CLOSED,
  SET_TOTAL_QUEUE,
} from './mutation-types';
import State from './state';
import RootState from '../../state'
import applicationTrackingSystemService from '../../../services/applicationTrackingSystemService'
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { IFilterApplicationList } from '../../../models/interfaces/applicationTrackingSystem/iFilterApplicationList';
import { IMessage } from "../../../models/interfaces/applicationTrackingSystem/iMessage";
import { IApplicationStatus } from "../../../models/interfaces/applicationTrackingSystem/iApplicationStatus";
import { IAnswerToQuestion } from "../../../models/interfaces/nonprofitProfile/iAnswerToQuestion";
import { IEditApplicationAnswersOutput } from "../../../models/interfaces/applicationTrackingSystem/iEditApplicationAnswersOutput";
import { QuestionToApply } from "../../../models/classes/nonprofitProfile/questionToApply";
import { IFeedback } from '../../../models/interfaces/applicationTrackingSystem/iFeedback';

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, RootState> = {

  getApplicationList({ commit, state }: ActionContext<State, RootState>, filterForApplicationList: IFilterApplicationList): Promise<any> {
    return new Promise((resolve, reject) => {
      applicationTrackingSystemService.getApplicationList(filterForApplicationList).then((rsp: any) => {
        let camilizedResponse: any = camelizer.convert(rsp);

        commit(SET_APPLICATION_LIST, camilizedResponse.data.applications);
        commit(SET_IS_ADMIN_VARIABLE, camilizedResponse.data.isAdmin);
        commit(SET_APPLICATIONS_EXIST, camilizedResponse.data.applicationsExist);

        commit(SET_TOTAL_OPEN, camilizedResponse.data.totalOpen);
        commit(SET_TOTAL_CLOSED, camilizedResponse.data.totalClosed);
        commit(SET_TOTAL_QUEUE, camilizedResponse.data.totalQueue);

        resolve(camilizedResponse)
      })
      .catch((error: any) => reject(error));
    })
  },

  loadMoreApplications({ commit, state }: ActionContext<State, RootState>, filterForApplicationList: IFilterApplicationList): Promise<any> {
    return new Promise((resolve, reject) => {
      applicationTrackingSystemService.getApplicationList(filterForApplicationList).then((rsp: any) => {
        let camilizedResponse: any = camelizer.convert(rsp);

        commit(LOAD_MORE_APPLICATIONS, camilizedResponse.data.applications);
        commit(SET_IS_ADMIN_VARIABLE, camilizedResponse.data.isAdmin);
        commit(SET_APPLICATIONS_EXIST, camilizedResponse.data.applicationsExist);

        commit(SET_TOTAL_OPEN, camilizedResponse.data.totalOpen);
        commit(SET_TOTAL_CLOSED, camilizedResponse.data.totalClosed);
        commit(SET_TOTAL_QUEUE, camilizedResponse.data.totalQueue);

        resolve(camilizedResponse)
      })
      .catch((error: any) => reject(error));
    })
  },

  setApplicationAnswers({ commit, state }: ActionContext<State, RootState>, editApplicationAnswersOutput: IEditApplicationAnswersOutput): Promise<any> {
    return new Promise((resolve, reject) => {
      applicationTrackingSystemService.editApplicationAnswers(editApplicationAnswersOutput).then(() => {
        commit(SET_APPLICATION_ANSWERS, editApplicationAnswersOutput.answers);
        resolve(true)
      });
    })
  },
    
  getApplication({ commit, state }: ActionContext<State, RootState>, applicationKey: string): Promise<any> {

    return new Promise((resolve, reject) => {
      applicationTrackingSystemService.getApplication(applicationKey).then((rsp: any) => {
        commit(SET_CURRENT_APPLICATION, camelizer.convert(rsp.data));

        resolve(rsp);
      })
      .catch((error: any) => reject(error));
    })
  },

  deleteApplication({ commit }: ActionContext<State, RootState>, applicationKey: string): Promise<any> {
    return new Promise((resolve, reject) => {
      commit(DELETE_APPLICATION_CARD, applicationKey);
      resolve(true);
    })
  },

  addNewMessage({ commit }: ActionContext<State, RootState>, message: IMessage): Promise<any> {
    return new Promise((resolve, reject) => {
      commit(ADD_NEW_MESSAGE, message);
      resolve(true);
    })
  },


  setApplicationStep({ commit }: ActionContext<State, RootState>, status: IApplicationStatus): Promise<any> {
    return new Promise((resolve, reject) => {
      commit(SET_APPLICATION_STEP, status);
      resolve(true);
    })
  },

  addFeedback(
    { commit }: ActionContext<State, RootState>,
    feedback: IFeedback
    ): Promise<any> {
    return new Promise((resolve, reject) => {
      applicationTrackingSystemService
      .addFeedback(feedback)
      .then((rsp: any) => {
        commit(ADD_FEEDBACK, camelizer.convert(rsp.data));
  
        resolve(rsp);
      })
      .catch((error: any) => reject(error));
    });
    },
};

export default actions;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/applicationTrackingSystem/actions.ts